import {
  GET_OFFERS_SENT_STAT,
  GET_OFFERS_SENT_STAT_SUCCESS,
  GET_OFFER_AMOUNT_STAT,
  GET_OFFER_AMOUNT_STAT_SUCCESS,
  GET_OFFER_STATUS_STAT,
  GET_OFFER_STATUS_STAT_SUCCESS,
  GET_OVERVIEW_NUMBERS,
  GET_OVERVIEW_NUMBERS_SUCCESS,
  GET_PRODUCTS_LISTED_STAT,
  GET_PRODUCTS_LISTED_STAT_SUCCESS,
  GET_PRODUCT_VALUE_STAT,
  GET_PRODUCT_VALUE_STAT_SUCCESS,
} from "../../actions/ecommerce/types";

const initialState = {
  numbers: { shops: 0, products: 0, productsViewed: 0, offers: 0 },
  numbersLoading: false,
  stats: {
    productsListedStat: { values: [], labels: [] },
    productsListedLoading: false,
    offersSentStat: { values: [], labels: [] },
    offersSentLoading: false,
    productValueStat: { values: [], labels: [] },
    productValueLoading: false,
    offerAmountStat: { values: [], labels: [] },
    offerAmountLoading: false,
    offerStatusStat: { approved: 0, pending: 0, declined: 0 },
    offerStatusLoading: false,
  },
};

export const overview = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_OVERVIEW_NUMBERS:
      return {
        ...state,
        numbersLoading: true,
      };
    case GET_OVERVIEW_NUMBERS_SUCCESS:
      return {
        ...state,
        numbersLoading: false,
        numbers: payload,
      };

    case GET_PRODUCTS_LISTED_STAT:
      return {
        ...state,
        stats: { ...state.stats, productsListedLoading: true },
      };
    case GET_PRODUCTS_LISTED_STAT_SUCCESS:
      return {
        ...state,
        stats: {
          ...state.stats,
          productsListedLoading: false,
          productsListedStat: payload,
        },
      };

    case GET_OFFERS_SENT_STAT:
      return {
        ...state,
        stats: { ...state.stats, offersSentLoading: true },
      };
    case GET_OFFERS_SENT_STAT_SUCCESS:
      return {
        ...state,
        stats: {
          ...state.stats,
          offersSentLoading: false,
          offersSentStat: payload,
        },
      };
      case GET_OFFER_AMOUNT_STAT:
        return {
          ...state,
          stats: { ...state.stats, offerAmountLoading: true },
        };
      case GET_OFFER_AMOUNT_STAT_SUCCESS:
        return {
          ...state,
          stats: {
            ...state.stats,
            offerAmountLoading: false,
            offerAmountStat: payload,
          },
        };
  
    case GET_PRODUCT_VALUE_STAT:
      return {
        ...state,
        stats: { ...state.stats, productValueLoading: true },
      };
    case GET_PRODUCT_VALUE_STAT_SUCCESS:
      return {
        ...state,
        stats: {
          ...state.stats,
          productValueLoading: false,
          productValueStat: payload,
        },
      };

    case GET_OFFER_STATUS_STAT:
      return {
        ...state,
        stats: { ...state.stats, offerStatusLoading: true },
      };
    case GET_OFFER_STATUS_STAT_SUCCESS:
      return {
        ...state,
        stats: {
          ...state.stats,
          offerStatusLoading: false,
          offerStatusStat: payload,
        },
      };

    default: {
      return state;
    }
  }
};
